module.exports = __webpack_public_path__ + "media/images/procedure_managements/examples/actors_mobile-b667187fa64dff970485947aac25345b.jpg";